import JSZip from "jszip";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
export const returnXmlStringFromFileObj = f_blob => {
  return new Promise(function(resolve, reject) {
    JSZip.loadAsync(f_blob) // 1) read the Blob
      .then(
        function(zip) {
          var xml_file = null;
          zip.forEach(function(relativePath, zipEntry) {
            // 2) print entries
            // console.log(relativePath);
            // console.log(zipEntry);
            if (
              zipEntry.name.endsWith("soundslide.xml") &&
              !zipEntry.name.startsWith("__MACOSX")
            ) {
              xml_file = zipEntry.name;
            }
          });
          // Read xml.
          if (xml_file) {
            zip
              .file(xml_file)
              .async("string")
              .then(text => {
                resolve(text);
              });
          } else {
            reject("No xml file in zip.");
          }
        },
        function(e) {
          reject(e);
        }
      );
  });
};

export const returnLargestVersionOfFileFromBlob = (f_blob, filename) => {
  return new Promise(function(resolve, reject) {
    JSZip.loadAsync(f_blob) // 1) read the Blob
      .then(
        function(zip) {
          var entries_matching_filename = [];
          zip.forEach(function(relativePath, zipEntry) {
            // 2) print entries
            //console.log(relativePath);
            //console.log(zipEntry);
            if (
              zipEntry.name.endsWith(filename) &&
              !zipEntry.name.startsWith("__MACOSX")
            ) {
              entries_matching_filename.push(zipEntry);
            }
          });
          // Find the largest one.
          var sortedBySize = reverse(
            sortBy(entries_matching_filename, i => {
              return i._data.uncompressedSize;
            })
          );
          //console.log("sortedBySize", sortedBySize);
          if (sortedBySize.length > 0) {
            zip
              .file(sortedBySize[0].name)
              .async("blob")
              .then(blob => {
                // Convert to File from blob.
                // https://stackoverflow.com/questions/27159179/how-to-convert-blob-to-file-in-javascript
                blob.lastModifiedDate = sortedBySize[0].date;
                blob.name = sortedBySize[0].name;
                resolve(blob);
              });
          } else {
            return null;
          }
        },
        function(e) {
          reject(e);
        }
      );
  });
};

export const returnTxtStringFromFileObj = f_blob => {
  return new Promise(function(resolve, reject) {
    JSZip.loadAsync(f_blob) // 1) read the Blob
      .then(
        function(zip) {
          var txt_file = null;
          zip.forEach(function(relativePath, zipEntry) {
            // 2) print entries
            console.log(relativePath);
            if (
              zipEntry.name.endsWith("soundslide.txt") &&
              !zipEntry.name.startsWith("__MACOSX")
            ) {
              txt_file = zipEntry.name;
            }
          });
          // Read xml.
          if (txt_file) {
            zip
              .file(txt_file)
              .async("string")
              .then(text => {
                resolve(text);
              });
          } else {
            return null;
          }
        },
        function(e) {
          reject(e);
        }
      );
  });
};
